module.exports = __webpack_public_path__ + "dingbeauty/admin/img/lineFriend_1.ba5a47c6.jpg";